import { M8ProductDTO } from 'services/production/types';
import { ClientProduct } from 'types/clientProductTypes';
import { normalizeM8TariffParts } from './normalizeM8TariffParts';

export const normalizeM8ProductDTO = (m8ProductDTO: M8ProductDTO) => ({
  toClientProduct(): ClientProduct {
    const calculation = normalizeM8TariffParts(
      m8ProductDTO.details
    ).toClientProductCalculation();

    return {
      id: m8ProductDTO.id,
      m8ProductType: m8ProductDTO.component,
      calculation,
      description: m8ProductDTO.componentName,
      defaultPartnerComission: m8ProductDTO.defaultPartnerComission,
    };
  },
});
